import contract from 'truffle-contract';

import { getWeb3 } from './web3Helpers';
import WorldCupPlayerTokenABI from './abis/AuctionableWorldCupPlayerToken.json';

export const AuctionableWorldCupPlayerTokenContract = new Promise((resolve, reject) => {
  getWeb3().then((web3) => {

    var AuctionableWorldCupPlayerTokenContract = contract(WorldCupPlayerTokenABI);
    AuctionableWorldCupPlayerTokenContract.setProvider(web3.currentProvider);
    AuctionableWorldCupPlayerTokenContract.deployed().then((instance) => {
      resolve(instance);
    });

  }).catch((error) => { reject(error); });
});





// WEBPACK FOOTER //
// ./src/util/contracts.js